draggableTimerecordDirective.$inject = ['$parse'];

export function draggableTimerecordDirective($parse) {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      attrs.$set('draggable', 'true');

      element.bind('dragstart', function (event) {
        //This is required as jquery wrap the original event
        const theEvent = event.originalEvent;

        theEvent.dataTransfer.effectAllowed = 'move';
        const timerecord = $parse(attrs.timerecord)(scope);
        timerecord.dragged = true;
        scope.$apply();

        const jsonTimerecord = JSON.stringify(timerecord);

        const type = 'application/x-timerecord.timerecord+json';

        try {
          theEvent.dataTransfer.setData(type, jsonTimerecord);
        } catch (e) {
          // only text is supported (IE workarround => include type in data)
          theEvent.dataTransfer.setData('Text', type + '\t' + jsonTimerecord);
        }

        return true;
      });

      element.bind('dragend', function () {
        const timerecord = $parse(attrs.timerecord)(scope);
        timerecord.dragged = false;
        scope.$apply();
      });
    },
  };
}
